/**
 * Check if the value is filled with a valid value.
 * For example, undefined or null will not be considered as filled
 * 
 * Motivation: zero (0) is considered as false in v-if condition
 * @param {*} value 
 * @returns {boolean}
 */
const filled = (value) => {
    return typeof value !== typeof undefined && value !== null;
};

export {
  filled,
};